import { useEffect, useState } from 'react'

import { type TrackUploadStatusEnum } from '@/shared/api'
import { PrimaryButton } from '@/shared/ui'
import { Button, Divider, Flex, Select, Space } from 'antd'
import { useUnit } from 'effector-react'

import { TrackUploadStatus } from '../../lib'
import {
  $jinglesTableFilters,
  jinglesTableFiltersChanged,
} from '../../model/jingles-table.model'

export const JinglesTableFiltersMenu = () => {
  const filters = useUnit($jinglesTableFilters)
  const uploadStatusesFilter = filters.UploadStatuses
  const changeFilters = useUnit(jinglesTableFiltersChanged)

  const [selectedUploadStatusesFilter, setSelectedUploadStatusesFilter] =
    useState<TrackUploadStatusEnum[] | undefined>(uploadStatusesFilter)

  useEffect(() => {
    const currentUploadStatusesFilter = filters.UploadStatuses
    if (currentUploadStatusesFilter !== selectedUploadStatusesFilter) {
      setSelectedUploadStatusesFilter(currentUploadStatusesFilter)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  return (
    <div style={{ width: 300 }}>
      <Divider style={{ marginTop: 0, marginBottom: 8 }} />
      <Flex vertical gap={8}>
        Статус загрузки
        <Select
          mode="multiple"
          showSearch={false}
          optionFilterProp="label"
          value={selectedUploadStatusesFilter}
          onChange={setSelectedUploadStatusesFilter}
        >
          <Select.Option
            key={TrackUploadStatus.Uploaded}
            value={TrackUploadStatus.Uploaded}
            label="Загруженные"
          >
            Загруженные
          </Select.Option>
          <Select.Option
            key={TrackUploadStatus.Uploading}
            value={TrackUploadStatus.Uploading}
            label="Не загруженные"
          >
            Не загруженные
          </Select.Option>
          <Select.Option
            key={TrackUploadStatus.DeletionPending}
            value={TrackUploadStatus.DeletionPending}
            label="Помеченные на удаление"
          >
            Помеченные на удаление
          </Select.Option>
        </Select>
      </Flex>
      <Space style={{ marginTop: 16 }}>
        <Button
          onClick={() => {
            setSelectedUploadStatusesFilter([TrackUploadStatus.Uploaded])
            changeFilters({
              UploadStatuses: [TrackUploadStatus.Uploaded],
            })
          }}
        >
          Сбросить
        </Button>
        <PrimaryButton
          onClick={() => {
            if (selectedUploadStatusesFilter === uploadStatusesFilter) return
            changeFilters({
              UploadStatuses: selectedUploadStatusesFilter,
            })
          }}
        >
          Применить
        </PrimaryButton>
      </Space>
    </div>
  )
}
